import ReactPlayer from "react-player"

export const Step = ({ className, url, question, information = null, children }) => {
    return (
        <article className={"gap-8 step " + className}>
            {information ? (
                <div className="flex gap-4 w-full">
                    <div className="max-w-80 w-80 flex-1">
                        <ReactPlayer
                            url={url}
                            controls
                            className='react-player'
                            width="100%"
                            height="100%"
                        />
                    </div>
                    {information}
                </div>
            ) : (
                <div className="max-w-96">
                    <ReactPlayer
                        url={url}
                        controls
                        className='react-player'
                        width="100%"
                        height="100%"
                    />
                </div>
            )
            }
            <section className="relative w-full">
                <span className="absolute -left-8 text-sm text-light-grey top-1">
                    {question.number}
                </span>
                <div className="flex flex-col gap-3 max-h-96 overflow-y-scroll">
                    <h3 className="text-2xl text-light-grey">{question.question}</h3>
                    <p className="text-light-grey text-sm">{question.description}</p>
                    <fieldset className="flex flex-col">
                        {children}
                    </fieldset>
                </div>
            </section>
        </article >
    )
}